import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_vaping">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h1>Stop Vaping Challenge App by University Of Toronto</h1>
            <p>
              The use of e-cigarettes is a growing health concern, linking it to
              lung disease and mortality rates. Approximately 81 million adults
              in the US are daily electronic cigarettes users.
            </p>
            <p>
              To minimize vaping, Stop vaping was designed to be a digital
              solution for teens and young adults to cut down on nicotine intake
              and e-cigarettes, and reduce adverse health effects. The app is
              central to providing motivation and easy solutions to opt for a
              healthy and opportunistic lifestyle.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="vaping_img">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={621}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
